import * as React from 'react';

import {
    Menu,
    Stack,
    Button,
    MenuItem,
    ButtonGroup,
    Paper,
    Chip,
    Typography,
    Divider,
    Box
} from '@mui/material';

// import {
//     Delete as DeleteIcon,
//     MoreVert as MoreVertIcon,
//     ArrowDropDown as ArrowDropDownIcon
// } from '@mui/icons-material';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';

import { CommonIcons, icons } from './CommonIcons'

import { useTranslations } from "../../hooks/useTranslations"

export default function DataGridToolbar({
    selectedRowCount,
    mainMenus,
    actionMenus,
    actionOnClickRemove,
    actionOnClickCancel
}) {

    const { t } = useTranslations({ ns: ["common"] })

    // console.log('actionMenus', actionMenus)

    // double check if both also dont have return empty
    if (
        mainMenus.length <= 0 &&
        (actionOnClickCancel === null || actionOnClickRemove === null)
    ) return <></>


    return (
        <Paper
            elevation={0}
            sx={{
                // mb: 1,
                pt: 2,
                pb: 2,
                pl: 1,
                pr: 1,
                // p: 1,
                // bgcolor: "red"
                // height: 80,
                width: '100%'
            }}
        >
            <Stack
                flexDirection={"row"}
                justifyContent={"space-between"}
            >
                <Stack
                    direction={"row"}
                    spacing={1}
                    justifyContent={"space-between"}
                >
                    {
                        mainMenus.map((item, index) => {

                            const {
                                ButtonProps,
                                ButtonStyle
                            } = item;

                            let buttonProps = {
                                variant: "contained",
                            }

                            if (ButtonProps) {
                                buttonProps = { ...buttonProps, ...ButtonProps }
                            }

                            let buttonStyle = {
                                textTransform: 'capitalize',
                                display: "flex",
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }

                            if (ButtonStyle) {
                                buttonStyle = { ...buttonStyle, ...ButtonStyle }
                            }

                            return (
                                <Button
                                    key={index}
                                    {...buttonProps}
                                    onClick={() => {
                                        // if (item?.onClick) item.onClick();
                                        if (item?.blank && item?.url) {
                                            window.open(item.url, '_blank', 'noopener,noreferrer')
                                        } else if (item?.url) {
                                            // ✅ same tab navigation (optional fallback)
                                            window.location.href = item.url
                                        } else if (item?.onClick) {
                                            item.onClick()
                                        }
                                    }}
                                    sx={buttonStyle}
                                >
                                    {
                                        item?.displayIconName &&
                                        <CommonIcons name={item.displayIconName} sx={{ mr: item?.displayText ? 1 : 0 }} />
                                    }
                                    <Box>
                                        {item?.displayText}
                                    </Box>
                                </Button>
                            )
                        })
                    }
                </Stack>
                {
                    ((actionMenus && actionMenus.length > 0) || actionOnClickRemove || actionOnClickCancel) &&
                    <PopupState
                        variant="popover"
                        popupId="dataGridToolbar"
                    >
                        {(popupState) => (
                            <>
                                <ButtonGroup variant="outline">
                                    {
                                        parseInt(selectedRowCount, 10) > 0 &&
                                        <Stack direction="row" spacing={1}>
                                            <Chip label={`${selectedRowCount} Selected`} />
                                        </Stack>
                                    }
                                    <Button
                                        {...bindTrigger(popupState)}
                                        size="small"
                                    // variant="outlined"
                                    // aria-controls={open ? 'split-button-menu' : undefined}
                                    // aria-expanded={open ? 'true' : undefined}
                                    // aria-label="select merge strategy"
                                    // aria-haspopup="menu"
                                    // onClick={handleToggle}
                                    >
                                        {/* <MoreVertIcon /> */}
                                        <CommonIcons name={icons.morevert} />
                                    </Button>
                                </ButtonGroup>

                                <Menu {...bindMenu(popupState)}>

                                    {/* <Stack sx={{ p: 1 }}>
                                    {MENU_OPTIONS.map((option) => (
                                        <MenuItem key={option.label} onClick={() => { navigateTo(option?.to) }}>
                                        {option.label}
                                        </MenuItem>
                                    ))}
                                </Stack> */}

                                    {
                                        actionMenus.map((item, index) => {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    sx={{
                                                        m: 1,
                                                    }}
                                                    onClick={() => {
                                                        popupState.close();

                                                        if (item?.onClick)
                                                            item.onClick(item);

                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            // textTransform: 'lowercase'
                                                        }}
                                                    >
                                                        {item?.displayText}
                                                    </Typography>
                                                </MenuItem>
                                            )
                                        })
                                    }

                                    {
                                        actionMenus.length > 0 &&
                                        <Divider sx={{ borderStyle: 'dashed' }} />
                                    }

                                    {
                                        actionOnClickRemove &&

                                        <MenuItem
                                            sx={{
                                                // m: 1,
                                                fontSize: '0.9rem'
                                            }}
                                            onClick={() => {
                                                popupState.close();

                                                actionOnClickRemove();

                                            }}
                                        >
                                            {/* <DeleteIcon color='secondary.main' fontSize='small' /> */}
                                            <CommonIcons name={icons.remove} />
                                            {t("remove")}
                                        </MenuItem>
                                    }

                                    {
                                        actionOnClickCancel &&

                                        <MenuItem
                                            sx={{
                                                // m: 1,
                                                fontSize: '0.9rem'
                                            }}
                                            onClick={() => {
                                                popupState.close();

                                                actionOnClickCancel();

                                            }}
                                        >
                                            {/* <DeleteIcon color='secondary.main' fontSize='small' /> */}
                                            <CommonIcons name={icons.cancel} />
                                            {t("cancel")}
                                        </MenuItem>
                                    }

                                </Menu>

                            </>
                        )}
                    </PopupState>
                }
            </Stack>
        </Paper>
    )

}